









import { Component, Vue, Prop, Model, Emit } from "vue-property-decorator";
import { Input, Button } from "ant-design-vue";

@Component({
  name: "CSendCode",
  components: {
    AInput: Input,
    AButton: Button
  }
})
export default class CSendCode extends Vue {
  @Model("input") value!: string;

  // 手机号码
  @Prop({ default: "" }) phonenumber!: string;

  // 是否登陆发送的短信
  @Prop({ default: false }) isLogin!: boolean;

  @Prop({ default: false }) inputPrefix!: boolean;

  private sendStatus = this.$enums.SendCodeStatus.undo;
  private btnText = this.$enums.SendCodeText.undo;
  private countTime = 60;

  private beforeSend() {
    this.$message.destroy();
    if (!this.phonenumber || !this.$tools.checkPhone(this.phonenumber)) {
      this.$message.error("您的手机号码格式不正确");
      return false;
    }

    return true;
  }

  private async sendCode() {
    const status = this.sendStatus;

    if (this.beforeSend()) {
      this.sendStatus = this.$enums.SendCodeStatus.doing;
      this.btnText = this.$enums.SendCodeText.doing;
      const res = await this.$api.SendCaptchaSMS({
        phonenumber: this.phonenumber,
        isLogin: this.isLogin,
        token: false
      });

      if (res && res.code === 200) {
        this.sendStatus = this.$enums.SendCodeStatus.done;
        // this.uuid = res.uuid;
        this.countdown();
        this.$emit("afterSend", res);
      } else {
        this.btnText = this.$enums.SendCodeText[status];
        this.sendStatus = status;
      }
    }
  }

  /**
   * 重发短信验证码倒计时
   */
  private countdown() {
    let left = this.countTime;
    this.btnText = `${this.$enums.SendCodeText.reset}(${left})`;

    const timer = window.setInterval(() => {
      left--;
      if (left === 0) {
        clearInterval(timer);
        this.btnText = this.$enums.SendCodeText.reset;
        this.sendStatus = this.$enums.SendCodeStatus.reset;
      } else {
        this.btnText = `${this.$enums.SendCodeText.reset}(${left})`;
      }
    }, 1000);
  }

  @Emit("input")
  handleInput(event: any) {
    return event.target.value;
  }
}
